<script>
  import { Headphones } from 'lucide-svelte';

  export let iconClass = '';
</script>

<Headphones class={iconClass} />
